import DataRow from './data-row';

export default DataRow;
